const Download = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fill='#424547'
      fillRule='nonzero'
      d='M11.25 14.44V3.75a.75.75 0 1 1 1.5 0v10.69l4.72-4.72a.75.75 0 0 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 1.06-1.06l4.72 4.72zM5.75 21a.75.75 0 1 1 0-1.5h12.5a.75.75 0 1 1 0 1.5H5.75z'
    />
  </svg>
);

export default Download;
